<section class="page-center-card">

  <div class="card mx-2">
    <div class="card-body">
      
      <div class="row">
    
        <div class="col-12 pb-2 px-sm-3">
          <label for="tipoConsulta">Tipo de consulta</label>
          <select [formControl]="form.controls.tipoConsulta" name="tipoConsulta" class="form-control">
            <option value=0>Selecione</option>
            <option *ngFor="let c of listaConsultas" [value]="c.id">{{c.nome}}</option>
          </select>
          <app-msg-erro [control]="form.controls.tipoConsulta"></app-msg-erro>
        </div>
    
        <div class="col-12 py-4 px-sm-3">
          <label *ngIf="!form.controls.arquivo.value" for="file-upload" class="btn btn-primary w-100 btn-icon pointer">
            <i class="mdi mdi-paperclip"></i>
            <span>Adicionar Arquivo</span>
            <input (change)="onFileSelect($event)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="custom-file-input position-absolute" type="file" name="file-upload" id="file-upload">
          </label>

          <button *ngIf="form.controls.arquivo.value" (click)="deleteFile()" class="btn btn-icon btn-danger w-100">
            <i class="mdi mdi-close"></i>
            <span>Remover arquivo</span>
          </button>

          <app-msg-erro [control]="form.controls.arquivo"></app-msg-erro>
        </div>
    
      </div>
      
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      <button (click)="enviar()" class="btn btn-lg btn-success px-5 mx-sm-3">
        Confirmar
      </button>
    </div>

  </div>

</section>